export function nullSafePath(...segments: any[]): string[] {
  return segments.filter(x => x !== null && x !== undefined);
}
